<template>
	<div class="products-list">
		<b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
		<h3>Import Products</h3>

		<div class="productExport">
			<input type="file" @change="loadTextFromFile" />
		</div>

		{{ progress }} of {{ product_total }}

		<div>
			<ul>
				<li v-for="(error, index) in errors" :key="index" class="update-error">
					{{ error }}
				</li>
			</ul>
		</div>
		<!-- <div v-if="progress > 0" class="progress-bar">
			<br /><br />
			<b-progress :value="Math.ceil(progress)" show-value format="percent" type="is-success" size="is-medium"></b-progress>
		</div> -->
	</div>
</template>

<script>
// @ is an alias to /src

export default {
	name: 'productsList',
	data: function() {
		return {
			isLoading: false,
			progress: 0,
			product_total: 0,
			errors: []
		}
	},

	mounted: async function() {},

	computed: {},

	methods: {
		async loadTextFromFile(ev) {
			this.isLoading = true
			const file = ev.target.files[0]
			const reader = new FileReader()

			reader.onload = async event => {
				var raw = event.target.result.split(/\r?\n/)

				var header = raw[0].split(/,/)

				let bd_code_index = header.indexOf('BD CODE')
				let selling_price_index = header.indexOf('SELLING PRICE')
				let purchase_price_index = header.indexOf('PURCHASE PRICE')
				let commission_index = header.indexOf('COMMISSION')

				if (bd_code_index == -1 || selling_price_index == -1 || purchase_price_index == -1 || commission_index == -1) {
					this.$swal.fire('Missing header!')

					this.isLoading = false

					return
				}

				// Remove first row
				raw.shift()

				this.product_total = raw.length

				// Loop every row to put it in array
				for (let data of raw) {
					// var splitData = data.split(/,/)
					var splitData = data.match(/(".*?"|[^",\s]+)(?=\s*,|\s*$)/g)

					if (splitData[bd_code_index]) {
						this.progress++

						const bd_code = splitData[bd_code_index]
						const price = splitData[selling_price_index]
						const purchase_price = splitData[purchase_price_index]
						const commission = splitData[commission_index]

						let data = { bd_code, price }

						if (purchase_price && purchase_price !== 0) {
							data.original_price = purchase_price
						} else {
							data.commission = commission
						}

						const apiUpdateProduct = await this.$api.productUpdate(data)

						if (!apiUpdateProduct) {
							this.errors.push('Error Updating ' + bd_code)
						}
					}
				}

				this.isLoading = false
			}

			reader.readAsText(file)
			this.isLoading = false
		}
	}
}
</script>

<style scoped>
@import '../styles/ProductsList.css';
</style>
